import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as ConversationCenterActions from '../conversation-center/actions';
import * as Actions from './actions';

const State = Record({
    searchResults: List(),
    fetchingSearchResults: false,
    currentQuery: '',
    selectedResultIndex: null,
    abortReason: undefined,
});

export default handleActions(
    {
        [Actions.search.type]: (state, {payload}) =>
            state.merge({
                fetchingSearchResults: true,
                currentQuery: payload.queryString,
                abortReason: undefined,
            }),
        [Actions.searchFailed.type]: state =>
            state.merge({
                fetchingSearchResults: false,
                abortReason: undefined,
            }),
        [Actions.searchAborted.type]: (state, {payload}) => {
            return state.merge({
                fetchingSearchResults: false,
                abortReason: payload.abortReason,
            });
        },
        [Actions.searchSuccess.type]: (state, {payload}) =>
            state.merge({
                searchResults: payload.results,
                fetchingSearchResults: false,
                abortReason: undefined,
            }),
        [Actions.setCurrentQuery.type]: (state, {payload}) =>
            state.merge({
                currentQuery: payload.queryString,
                abortReason: undefined,
            }),
        [Actions.selectSearchResult.type]: (state, {payload}) =>
            state.merge({
                selectedResultIndex: payload.index,
            }),
        [Actions.selectNextSearchResult.type]: (state, {payload}) => {
            return state.merge({
                selectedResultIndex: state.selectedResultIndex + payload.direction,
            });
        },
        [ConversationCenterActions.setInboxType.type]: () => new State(),
    },
    new State(),
);
